// extracted by mini-css-extract-plugin
module.exports = {"container":"personalData_container__gMKtN","divider":"personalData_divider__u6_b_","header":"personalData_header__bl3ln"};